export default __webpack_public_path__ + "static/media/image2.cf27111a.jpg";